<template>
    <div class="page gray_bg notification">
        <BACK title="系統通知" :hidBack="true"/>
        <div class="mess_list" v-infinite-scroll="handleGetList" infinite-scroll-delay="100"
             infinite-scroll-immediate="false">
            <el-empty v-if="notification_empty && !add_loading" description="尚無通知"></el-empty>
            <div class="system_notifycation" v-for="({title,content,date,isRead},i) in notificationList" :key="i">
                <span class="date">{{date | moment("YYYY/MM/DD h:mm")}}</span>
                <el-card shadow="always">
                    <div class="info">
                        <el-badge :is-dot="!isRead >0 " style="width: 100%;">
                            <div class="title">
                                <div class="color_primary" v-html="title"></div>
                            </div>
                        </el-badge>
                        <div class="content" v-html="content"></div>

                    </div>
                </el-card>
            </div>
        </div>
        <div v-loading="add_loading" element-loading-background="rgba(0, 0, 0, 0)"
             style="width: 100%;height: 80px"></div>
        <MENU/>
    </div>

</template>
<style>

</style>
<script>

    import BACK from '@/components/back.vue'
    import FN from '@/components/fn'
    import {mapGetters, mapActions} from 'vuex'
    import MENU from '@/components/menu.vue'

    export default {
        name: 'Registered',
        components: {
            BACK,
            MENU
        },
        mixins: [FN],
        data() {
            return {
                notification_empty: true,
                notificationList: [],
                ids: [],
                page: 1,
                add_loading: true
            }
        },
        mounted() {
            this.handleGetList()
        },
        computed: {
            // ...mapGetters([
            //     'notificationList'
            // ]),

        },
        methods: {
            ...mapActions([
                'FETCH'
            ]),
            //送出表單
            handleGetList() {
                this.add_loading = true;
                this.FETCH({
                    key: 'NOTIFICATION_R',
                    page: this.page
                }).then((res) => {
                    if (+(res || {}).code === -3) {
                        this.checkNewToken(this.handleGetList)
                    } else {

                        for (var i = 0; i < res.pagination.data.length; i++) {
                            this.notification_empty = false;
                            var id = res.pagination.data[i].id
                            if (!this.ids.includes(id)) {
                                console.log('strat');
                                this.ids.push(res.pagination.data[i].id);
                                this.notificationList.push(res.pagination.data[i]);
                                console.log('end');
                            }
                        }
                        if (this.page < res.pagination.last_page) {
                            this.page += 1;
                        }
                    }
                    this.add_loading = false;
                })

            }
        }
    }
</script>
